var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69.45 69.45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient",
    x1: 34.72,
    x2: 34.72,
    y2: 69.45
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78d2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3458e9"
  })))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 34.72,
    cy: 34.72,
    r: 34.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.65,20.16l1.12-1.93a2.52,2.52,0,0,1,4.37,2.51L29.35,39.41h7.8a3.45,3.45,0,0,1,2.85,5H17.13a2.52,2.52,0,1,1,0-5h6.41l8.21-14.23-2.56-4.45a2.52,2.52,0,1,1,4.36-2.51l1.1,1.94ZM25,47l-2.42,4.2a2.52,2.52,0,0,1-4.37-2.52L20,45.6A4.32,4.32,0,0,1,25,47Zm20.83-7.6h6.54a2.52,2.52,0,0,1,0,5H48.68l2.46,4.25a2.52,2.52,0,0,1-4.37,2.52q-6.19-10.75-9.29-16.1a7,7,0,0,1,.88-8.52q2.47,4.25,7.42,12.82Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.32fa7709761455ae32c9b4d570060042.svg";
export { ForwardRef as ReactComponent };